// src/pages/Contato.jsx
import { Helmet } from "react-helmet-async";

/* ================= WHATSAPP (PADRÃO DO SITE) ================= */
function getWhatsAppLink(pathname) {
  const number = "5527995785444";

  let intro = "Olá! Quero uma proposta para meu evento.";
  let context = "";

  if (pathname === "/cenografia") {
    context = "Tenho interesse em um projeto de CENOGRAFIA.";
  } else if (pathname === "/iluminacao") {
    context = "Tenho interesse em um projeto de ILUMINAÇÃO CÊNICA.";
  } else if (pathname === "/portfolio") {
    context = "Vi o portfólio e quero algo nesse nível.";
  } else if (pathname === "/contato") {
    context = "Quero conversar sobre um projeto.";
  }

  const text = encodeURIComponent(
    `${intro}\n\n${context}\n\n` +
      "• Data do evento:\n" +
      "• Cidade/Local:\n" +
      "• Tipo de evento (corporativo/casamento/outro):\n" +
      "• O que você precisa (cenografia/iluminação/ambos):\n" +
      "• Referências (se tiver):\n"
  );

  return `https://wa.me/${number}?text=${text}`;
}

/* ================= ÍCONES (INLINE) ================= */
function IconWhatsApp() {
  return (
    <svg width="22" height="22" viewBox="0 0 32 32" aria-hidden="true">
      <path
        fill="currentColor"
        d="M16 3C9.4 3 4 8.4 4 15c0 2.4.7 4.7 2 6.7L4 29l7.6-2c1.9 1 4 1.6 6.4 1.6 6.6 0 12-5.4 12-12S22.6 3 16 3zm6.7 17.1c-.3.8-1.6 1.5-2.2 1.6-.6.1-1.3.2-2.2-.1-.5-.2-1.2-.4-2-.9-3.5-1.9-5.8-5.1-6-5.4-.2-.3-1.4-1.9-1.4-3.6 0-1.7.9-2.6 1.2-3 .3-.4.7-.5 1-.5h.7c.2 0 .5-.1.8.6.3.7 1 2.4 1.1 2.6.1.2.1.5 0 .7-.1.2-.2.5-.4.7-.2.2-.4.4-.6.7-.2.2-.4.5-.2.8.2.3.9 1.5 2 2.5 1.4 1.2 2.6 1.6 3 1.8.4.2.6.2.9-.1.3-.3 1-1.1 1.3-1.5.3-.4.6-.3.9-.2.4.1 2.3 1.1 2.7 1.3.4.2.7.3.8.5.1.2.1.8-.2 1.6z"
      />
    </svg>
  );
}

function IconInstagram() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M7.5 2h9A5.5 5.5 0 0 1 22 7.5v9A5.5 5.5 0 0 1 16.5 22h-9A5.5 5.5 0 0 1 2 16.5v-9A5.5 5.5 0 0 1 7.5 2Zm0 2A3.5 3.5 0 0 0 4 7.5v9A3.5 3.5 0 0 0 7.5 20h9A3.5 3.5 0 0 0 20 16.5v-9A3.5 3.5 0 0 0 16.5 4h-9ZM12 7a5 5 0 1 1 0 10a5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6a3 3 0 0 0 0-6Zm6.2-2.2a1.2 1.2 0 1 1-2.4 0a1.2 1.2 0 0 1 2.4 0Z"
      />
    </svg>
  );
}

function IconMail() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 4.2-8 5-8-5V6l8 5 8-5v2.2Z"
      />
    </svg>
  );
}

function Contato() {
  const title = "Contato | Cenografia e Iluminação Cênica | Cenovix";
  const description =
    "Fale com a Cenovix para projetos de cenografia e iluminação cênica. Atendimento direto via WhatsApp, Instagram ou e-mail. Base em Vila Velha/ES, atendimento Brasil.";
  const url = "https://www.cenovix.com.br/contato";
  const ogImage = "https://www.cenovix.com.br/images/og-cenovix.jpg";

  const waLink = getWhatsAppLink("/contato");
  const igLink = "https://www.instagram.com/ceno.vix";
  const email = "cenovixeventos@gmail.com";

  // ✅ Link “URL” para escrever e-mail (Gmail) — muito mais confiável que mailto:
  const emailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
    email
  )}`;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Cenovix",
    url: "https://www.cenovix.com.br/",
    telephone: "+55 27 99578-5444",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Vila Velha",
      addressRegion: "ES",
      addressCountry: "BR",
    },
    sameAs: [igLink],
  };

  return (
    // ✅ IMPORTANTE: aqui NÃO pode ser <main>, senão vira “main dentro de main” e cria o card extra
    <div className="contato">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />
        <meta name="robots" content="index,follow,max-image-preview:large" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Cenovix" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:image:alt" content="Contato Cenovix" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImage} />

        <meta name="theme-color" content="#0b0b0c" />

        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>

      {/* HERO (sem “card dentro de card”) */}
      <section aria-label="Contato Cenovix">
        <h1>Vamos conversar sobre o seu projeto</h1>
        <p>
          Projetos sob medida, com foco em leitura de marca, atmosfera e resultado
          em foto e vídeo.
          <br />
          <span style={{ opacity: 0.92 }}>
            Localizados em <strong>Vila Velha</strong>, atendemos todo{" "}
            <strong>Brasil</strong>.
          </span>
        </p>
      </section>

      {/* BOTÕES PREMIUM (plataformas) */}
      <section aria-label="Canais de contato">
        <h2>Canais de contato</h2>

        <div className="contact-actions">
          <a
            className="contact-action contact-action--wa"
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Falar no WhatsApp"
          >
            <span className="contact-action__icon" aria-hidden="true">
              <IconWhatsApp />
            </span>
            <span className="contact-action__text">
              <span className="contact-action__title">WhatsApp</span>
              <span className="contact-action__sub">Atendimento direto</span>
            </span>
            <span className="contact-action__arrow" aria-hidden="true">
              →
            </span>
          </a>

          <a
            className="contact-action contact-action--ig"
            href={igLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Abrir Instagram da Cenovix"
          >
            <span className="contact-action__icon" aria-hidden="true">
              <IconInstagram />
            </span>
            <span className="contact-action__text">
              <span className="contact-action__title">Instagram</span>
              <span className="contact-action__sub">@ceno.vix</span>
            </span>
            <span className="contact-action__arrow" aria-hidden="true">
              →
            </span>
          </a>

          <a
            className="contact-action contact-action--mail"
            href={emailLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Escrever e-mail para a Cenovix"
            title="Escrever e-mail para a Cenovix"
          >
            <span className="contact-action__icon" aria-hidden="true">
              <IconMail />
            </span>
            <span className="contact-action__text">
              <span className="contact-action__title">E-mail</span>
              <span className="contact-action__sub">{email}</span>
            </span>
            <span className="contact-action__arrow" aria-hidden="true">
              →
            </span>
          </a>
        </div>
      </section>

      {/* CTA FINAL (reforço) */}
      <section aria-label="Chamada para WhatsApp">
        <h2>Prefere falar direto?</h2>
        <p>
          Envie no WhatsApp a <strong>data</strong>, o <strong>local</strong> e o{" "}
          <strong>tipo de evento</strong>. A gente conduz o resto com você.
        </p>

        <a
          className="cta"
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Falar no WhatsApp"
        >
          Falar no WhatsApp
        </a>
      </section>
    </div>
  );
}

export default Contato;
